export default __webpack_public_path__ + "static/gsmith-e48064034c4297accbaebfc1f00d1f8c.jpeg";